import type { FieldError } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Animated, { FadeInUp, FadeOutDown } from 'react-native-reanimated';
import { Text } from './text';

export interface FormErrorProps {
  error?: FieldError;
  errorMessage?: string;
}

export function FormError({ error, errorMessage }: FormErrorProps) {
  const { t } = useTranslation();

  if (!error?.message && !errorMessage) return null;

  return (
    <Animated.View entering={FadeInUp.duration(150)} exiting={FadeOutDown.duration(50)}>
      <Text accessibilityRole="alert" color="border.error">
        {error?.message ? t(error.message) : errorMessage!}
      </Text>
    </Animated.View>
  );
}
